import React, { Suspense } from "react"
import { Spinner, Center } from "@chakra-ui/react"

const BlockErrorHandler = React.lazy(
  () =>
    import("./BlockErrorHandler" /* webpackChunkName: "BlockErrorHandler" */)
)

const BlockErrorHandlerLazy = (props: any) => {
  return (
    <Suspense
      fallback={
        <Center>
          <Spinner />
        </Center>
      }
    >
      <BlockErrorHandler {...props} />
    </Suspense>
  )
}

export default BlockErrorHandlerLazy
